module.exports = __webpack_public_path__ + "img/Investments.013cc017.svg";